import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

export default function HoverToolTip({text,forceHug=-5,forceAbove=false,checkScroll=false}:{text:string,forceHug?:number,forceAbove?:boolean,checkScroll?:boolean}){

    const fixed = true;

    const [mousePos,setMousePos] = useState({x:-1000,y:-1000});
    const [isActive,setIsActive] = useState(false);
    const [isReversed,setIsReversed] = useState(false); // if true, the tooltip will be on the top of the mouse instead of the bottom
    const [hugState,setHugState] = useState(0); // when near the left or right edge of screen, offset the tooltip and tooltip caret
    const isTouching = useRef(false);
    const ref = useRef<HTMLDivElement>(null);
    const [parent,setParent] = useState<HTMLElement|null>(null);
    const onMouseMove = ()=>{

   
        if(isTouching.current){ // indicates there was a touch up event preceding this
            isTouching.current = false;
            return;
        }
        

        let bounds = ref.current?.parentElement?.getBoundingClientRect();
       


        if(!bounds){
            return;
        }

        
         let x = bounds.left + bounds.width*.5;
        let y = bounds.top + bounds.height*.5;
      
        let reverse = (y<250&&!forceAbove);

        let newHugState = 0;
        if(x>window.innerWidth-200 || forceHug===-1){
            newHugState = -1
        }


        if(forceHug===0){
            newHugState = 0;
        }

        if(newHugState!==hugState){
            setHugState(newHugState);
        }

        if(reverse!==isReversed)
            setIsReversed(reverse);

    

        if(bounds && fixed){

            if(bounds.left<60){
                setMousePos({x:(60)+16*-newHugState,y:(reverse)?bounds.bottom:bounds.top });
            }
            else
            setMousePos({x:(bounds.left*.5+bounds.right*.5)+16*-newHugState,y:(reverse)?bounds.bottom:bounds.top });

        }
        else{
            setMousePos({x:x+16*-newHugState,y:y  });
        }
        setIsActive(true);
        
    }

    const onScroll = ()=>{
        onMouseLeave();

    }

    const onMouseLeave = ()=>{
       setMousePos({x:-1000,y:-1000});
       setIsActive(false);
   
    
    }

    const onTouchEnd = ()=>{
     
        isTouching.current = true;
        onMouseLeave();
    }

    useEffect(() => {

        if (checkScroll && parent) {
          const closestScroll = parent?.closest(".nice-scroll");
          if (closestScroll) {
            closestScroll.addEventListener("scroll", onScroll);
          }
        }
        return () => {
          if (checkScroll) {
            const closestScroll = parent?.closest(".nice-scroll");
            if (closestScroll) {
              closestScroll.removeEventListener("scroll", onScroll);
            }
          }
        };
        //eslint-disable-next-line
    },[isActive]);

    useEffect(() => {

        if(ref.current && !parent){
            const getParent = ref.current.parentElement;
         
            if(getParent){
                setParent(getParent);

                getParent.addEventListener("mouseenter",onMouseMove);

                getParent.addEventListener("mouseleave",onMouseLeave);

                getParent.addEventListener("touchend",onTouchEnd);

             

            }
        }

        return()=>{
            if(parent){
             
                parent.removeEventListener("mouseenter",onMouseMove);
                parent.removeEventListener("mouseleave",onMouseLeave);
                parent.removeEventListener("touchend",onTouchEnd);

          
             
            }

        }
//eslint-disable-next-line
    }, [])


 
    let hugClass = (hugState===0)?"":(hugState===1?" left ":" right ");
   
    let xTransform = "-50%";
    if(hugState===1){
        xTransform="0%"
    }
    else if(hugState===-1){
        xTransform="-100%"
    }
    let yTransform = (isReversed?"0%":"-100%");




 return <div ref = {ref}>  
     {isActive &&
     ReactDOM.createPortal(<div  
        className={"slow-fade " + (isReversed?"up-caret ":"down-caret ") +hugClass}
        style={{
            position:"fixed",
            left:mousePos.x+"px",top:mousePos.y+"px",
            padding:"8px 12px",
            borderRadius:"4px",
            backgroundColor:"#555",
            width:"max-content",
            fontSize:"12px",
            maxWidth:"300px",
            transform: `translate(${xTransform},${yTransform})`,
            color:"white",
            zIndex:5000,display:(isActive?"block":"block"),pointerEvents:"none"
        }}>
        {  
            text    
        }
    </div>,document.body)}
    </div>




}